module.exports = __webpack_public_path__ + "54cf98f5/img/google.68f3823e.svg";